import {
  OPEN_SIDEBAR,
  CLOSE_SIDEBAR,
  OPEN_USER_BAR,
  CLOSE_USER_BAR,
  NAVIGATION_INIT
} from './action-types';

export function openSideBar() {

  return {
    type: OPEN_SIDEBAR
  };
}

export function closeSideBar() {

  return {
    type: CLOSE_SIDEBAR
  };
}

export function openUserBar() {
  return {
    type: OPEN_USER_BAR
  };
}

export function closeUserBar() {
  return {
    type: CLOSE_USER_BAR
  };
}

export function navigationInit() {
  return {
    type: NAVIGATION_INIT
  };
}


// WEBPACK FOOTER //
// ./src/core/services/navigation/action-creators.js